/** Guide sections shown in the Roadtrip menu (not day-by-day). */
export const ROADTRIP_MENU_LABEL = 'Roadtrip';

export const ROADTRIP_SECTIONS = [
  { key: 'whereToEat', label: 'Dove mangiare', icon: '🍽️' },
  { key: 'rainPlanB', label: 'Piano B pioggia', icon: '☔' },
  { key: 'quickPick', label: 'Scelta rapida', icon: '⚡' },
  { key: 'slovenePhrases', label: 'Frasi utili', icon: '💬' },
  { key: 'ticketsSummary', label: 'Biglietti', icon: '🎟️' },
];

export const ROADTRIP_DEFAULT_ICON = '🗺️';

export function sectionByKey(key) {
  return ROADTRIP_SECTIONS.find((s) => s.key === key) ?? null;
}

export function sectionIcon(key) {
  return sectionByKey(key)?.icon ?? ROADTRIP_DEFAULT_ICON;
}

export function sectionLabel(key) {
  return sectionByKey(key)?.label ?? key;
}
